// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  LIGHTBOX_TITLE: 'Flight Finder',
  SELECT_FLIGHT: 'Find My Flight',
  YOUR_FLIGHT_PLACEHOLDER: 'Select your flight',
  YOUR_AIRLINE_LABEL: 'Airline',
  YOUR_AIRLINE_PLACEHOLDER: 'Type airline code or name',
  FLIGHT_TIME_LABEL_DEPARTING: 'Flight departing time at {airport}',
  FLIGHT_TIME_LABEL_LANDING: 'Flight landing time at {airport}',
  FLIGHT_TIME_PLACEHOLDER: 'Select your flight time',
  FLIGHT_DATE_LABEL: 'Date of your flight',
  FLIGHT_DATE_PLACEHOLDER: 'Select your flight date',
  FIELD_PLACEHOLER: 'Example: {airlineCode} 1234',
  FIELD_LABEL: 'Flight number',
  FLIGHT_FINDER_TOOL_TIP: "Don't know your flight number? {link}",
  FLIGHT_FINED_LINK: 'Try our flight finder tool',
  SELECT_TYPED_FLIGHT: 'Select "{flight}" anyway',
  CANT_FIND_FLIGHT_OPTION:
    "Can't find your flight? Don't worry, try our advanced search",
  ADVANCED_SEARCH_TIP: 'Open Advanced Search',
  BEST_MATCH: 'Best match',
  POSSIBLE_OPTIONS: 'Possible options',
  STILL_CANT_FIND: "Still can't find your flight?",
  STILL_CANT_FIND_NOTICE:
    'No problem, you can enter your flight number and our team will manually check it.',
  ENTER_FLIGHT_MANUALLY: 'Enter Flight Number',
  INCORRECT_FLIGHT_NUMBER:
    'Incorrect flight number format. The correct format is: XX 1234 or XXX 1234',
  LANDING_AT: 'landing at {airport}',
  DEPARTING_FROM: 'departing from {airport}',
  NO_FLIGHT_FOUND:
    "We couldn't find any flight with that number {direction} around {time}",
  ACCORDING_OUR_DATABASE:
    '* according to our database. You can still book and our team may follow up with you for clarification.',
  ORIGIN_AIRPORT: 'Origin Airport (Optional)',
  DESTINATION_AIRPORT: 'Destination Airport (Optional)',
  SELECT_ENTERED_FLIGHT: 'Select Flight Number',
  LAYOVER_EXPLANATION:
    'If your flight has a layover or stop, please enter the last airport your plane departs from before arriving at {airport}',
}

export default createMessages<typeof MESSAGES>(
  'UIKIT_FORM_FLIGHT_FINDER_FIELD',
  MESSAGES
)
